import { render, staticRenderFns } from "./OpenSalesDrawer.vue?vue&type=template&id=3d511de6&scoped=true"
import script from "./OpenSalesDrawer.vue?vue&type=script&lang=js"
export * from "./OpenSalesDrawer.vue?vue&type=script&lang=js"
import style0 from "./OpenSalesDrawer.vue?vue&type=style&index=0&id=3d511de6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d511de6",
  null
  
)

export default component.exports